<p-confirmDialog #cd [key]="key()" [closable]="false" [styleClass]="cd.styleClass" [dismissableMask]="false"
  [draggable]="false" [style]="{ width: '500px' }">
  <ng-template #message let-message>
    @if (message.messageTemplate; as template) {
    <ng-container [ngTemplateOutlet]="template" />
    } @else if (message.message) {
    <span [innerHTML]="message.message"></span>
    }
  </ng-template>
</p-confirmDialog>